import { useState } from 'react';

const navLinks = [
  { label: '今日瓜', href: '#today' },
  { label: '话题墙', href: '#topics' },
  { label: '新鲜爆料', href: '#leaks' },
  { label: '最新八卦', href: '#gossip' },
  { label: '热度榜', href: '#rank' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex max-w-[1280px] items-center justify-between gap-4 px-4 py-3 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
            <i className="ri-emotion-happy-line text-xl"></i>
          </span>
          <span className="font-heading text-xl leading-none text-foreground-950">1每日吃瓜</span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 transition hover:bg-secondary-100 hover:text-secondary-900"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <span className="hidden items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900 lg:flex">
            <i className="ri-refresh-line"></i>
            今日已更新 128 条
          </span>
          <a
            href="#join"
            className="hidden shrink-0 items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-bold text-white transition hover:bg-primary-600 sm:flex"
          >
            <i className="ri-door-open-line"></i>
            进入瓜房
          </a>
          <button
            type="button"
            aria-label="打开导航"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-200 py-3 text-sm font-medium text-foreground-800"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#join"
            onClick={() => setOpen(false)}
            className="mt-4 flex items-center justify-center gap-1 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-white"
          >
            <i className="ri-door-open-line"></i>
            进入瓜房
          </a>
        </div>
      ) : null}
    </div>
  );
}